module.exports = __webpack_public_path__ + "img/img-3.72eb4928.jpg";